import { getAxiosInstance } from '../util/service';
import { moduleTypes } from '../util/constants';

/**
 * Validate company code or domain
 * Returns subdomain if valid
 */
export const validateCompany = async (identificationType, value) => {
  try {
    const endpoint = '/onboarding/validate/company';
    
    const response = await getAxiosInstance(moduleTypes.DISPATCH).post(endpoint, {
      identificationType, // 'code' or 'domain'
      identificationValue: value
    });

    if (response.data.statusCode === 200) {
      return {
        success: true,
        subdomain: response.data.response.subdomain,
        companyName: response.data.response.companyName
      };
    } else {
      throw new Error(response.data.statusMsg || 'Invalid company code/domain');
    }
  } catch (error) {
    console.error('Company validation error:', error);
    
    if (error.response?.data?.statusMsg) {
      throw new Error(error.response.data.statusMsg);
    }
    
    throw new Error('Unable to validate company. Please check your code/domain and try again.');
  }
};

/**
 * Helper to extract subdomain from various formats
 * Handles: "acme", "acme.yourdomain.com", "https://acme.yourdomain.com"
 */
export const extractSubdomain = (input) => {
  if (!input) return null;

  // Remove protocol if present
  let domain = input.replace(/^https?:\/\//, '');
  
  // Remove trailing slash
  domain = domain.replace(/\/$/, '');
  
  // If it's just the subdomain (e.g., "acme"), return it
  if (!domain.includes('.')) {
    return domain.toLowerCase();
  }
  
  // Extract subdomain from full domain (e.g., "acme.yourdomain.com" → "acme")
  const parts = domain.split('.');
  if (parts.length >= 2) {
    return parts[0].toLowerCase();
  }
  
  return null;
};